import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import {
    DragSource as createDragSource,
    DropTarget as createDropTarget,
} from 'react-dnd';
import EditImagePresenceButtons from './images/EditImagePresenceButtons';
import flow from 'lodash/flow';
import OverlayImage from '../../../components/media/OverlayImage';

const ItemTypes = {
    IMAGE: 'image',
};

const style = {
    cursor: 'move',
};

/**
 * Implements the drag source contract.
 */
const imageSource = {
    beginDrag(props) {
        return { id: props.id };
    },
    isDragging(props, monitor) {
        return props.id === monitor.getItem().id;
    },
};

/**
 * Specifies the props to inject into your component.
 */
function collectDrag(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        isDragging: monitor.isDragging(),
    };
}

function collectDrop(connect) {
    return {
        connectDropTarget: connect.dropTarget(),
    };
}

const propTypes = {
    // Injected by React DnD:
    connectDragSource: PropTypes.func.isRequired,
    connectDropTarget: PropTypes.func.isRequired,
    isDragging: PropTypes.bool.isRequired,

    editHref: PropTypes.string.isRequired,
    img: PropTypes.shape({
        description: PropTypes.string,
        image: PropTypes.shape({
            urls: PropTypes.shape({
                preview: PropTypes.string.isRequired,
            }).isRequired,
        }).isRequired,
        occupations: PropTypes.arrayOf(
            PropTypes.shape({
                specialization: PropTypes.string.isRequired,
            })
        ).isRequired,
    }),
    imageIndex: PropTypes.number.isRequired,
    reorderImages: PropTypes.func.isRequired,
    onDeleteClick: PropTypes.func.isRequired,
    id: PropTypes.any.isRequired,
};

const imageTarget = {
    // swap on hover
    hover(props, monitor) {
        const draggedId = monitor.getItem().id;

        if (draggedId !== props.id) {
            props.swapImages(draggedId, props.id);
        }
    },
};

class DraggableImage extends React.Component {
    render() {
        const {
            img,
            reorderImages,
            onDeleteClick,
            imageIndex,
            editHref,
            connectDragSource,
            connectDropTarget,
        } = this.props;

        // const opacity = isDragging ? 0 : 1;

        const element = (
            <div className={this.props.className} style={style}>
                <div className="r-mvm r-mll">
                    <OverlayImage
                        defaultValue={img.description}
                        imgSrc={img.image.urls.preview}
                        tags={img.occupations.map((o) => o.specialization)}
                    />
                    <Link className="button button--flat" to={editHref}>
                        Endre
                    </Link>
                    <EditImagePresenceButtons
                        imageIndex={imageIndex}
                        onDeleteClick={onDeleteClick}
                        reorderImages={reorderImages}
                    />
                </div>
            </div>
        );

        return connectDragSource(connectDropTarget(element));
    }
}

DraggableImage.propTypes = propTypes;

export default flow(
    createDragSource(ItemTypes.IMAGE, imageSource, collectDrag),
    createDropTarget(ItemTypes.IMAGE, imageTarget, collectDrop)
)(DraggableImage);
